import { useEffect } from "react";
import { initializeGtag } from "@/utils/gtag";
import Index from "./Index";
// import PromotionPopupTrigger from "@/components/PromotionPopupTrigger"; // Import kısmını yorum satırı yaptık

export const Home = () => {
  useEffect(() => {
    initializeGtag();
  }, []);

  return (
    <>
      <Index />
      {/* <PromotionPopupTrigger /> */} {/* JSX içindeki component'i yorum satırı yaptık */}
    </>
  );
};

export default Home;